

var ur = window.location.href;
if(ur.includes('/product')){
  jQuery(document).ready(function(){
    jQuery('.white-box').eq(0).prepend(jQuery('h1.product__title'));

    
if(jQuery('.fh-buyNow').length == 0){
     jQuery('button.product-form__submit.button.button--full-width.button--primary').eq(0).after(jQuery('<div class="fh-buyNow">BUY NOW</div>'));
 }

  jQuery('.fh-buyNow').click(function(){
    var b = 0;
var timerb = setInterval(function(){
  if(jQuery('.shopify-payment-button__more-options').eq(0).length || b > 200) {
	 jQuery('.shopify-payment-button__more-options').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });
var ur = window.location.href;
Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var ctaCopy = "BUY NOW";
  var lnk = '#';
  var stickyCopy = jQuery('h1.product__title').eq(0).text();
      var stickyprice = jQuery('.price.price--large.price--on-sale.price--show-badge').eq(0).clone();
  
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="sticky-st-container" id="sticky-st-containerID"> <div class="sticky-st-container__outer"> <div class="sticky-st-container__inner"> <div class="sticky-st-copy"><p>'+stickyCopy+'</p> <div class="sticky-st-price"></div></div><div class="sticky-st-item_column__button"><a class="sticky-st-item__button">'+ctaCopy+'</a></div></div></div></div></div>';
var y = document.getElementsByTagName('body');
if (document.getElementsByClassName('sticky-st-container').length == 0) {
    y[0].appendChild(sticky);
  console.log('here');
}
$('.sticky-st-item__button').click(function(){
  $('.fh-buyNow').eq(0).click();
}); 
$('.sticky-st-price').append(stickyprice);

     setInterval(function(){ 
$('.sticky-st-price').eq(0).html(jQuery('.price.price--large.price--on-sale.price--show-badge').eq(0).parent().html())
}, 1000);
  
var mc = window.matchMedia("(min-width: 767px)");
var elem = document.getElementById("sticky-st-containerID");
function slideShow() {
    elem.style.bottom = "0px";
    jQuery('body').addClass('sticky-sticky');
}
function slideHide() {
  elem.style.bottom = "-200px";
   jQuery('body').removeClass('sticky-sticky');
}
  
jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
     if (y > $('.fh-buyNow').eq(0).offset().top) {
        slideShow();
    } else {
        slideHide();
    }
    
}); 

     setInterval(function(){ 
 if(jQuery('.shopify-payment-button__more-options').length && jQuery('.payment-options').length == 0) {
jQuery('.shopify-payment-button__more-options').eq(0).after(jQuery(`<div class="payment-options"><img src="https://cdn.shopify.com/s/files/1/0605/6086/7505/files/Group_32.png?v=1702375871" id="image1"><img src="https://cdn.shopify.com/s/files/1/0605/6086/7505/files/Group_31.png?v=1702375871" id="image2"></div>`))	
 }
}, 50);
 


Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = ['https://cdn.shopify.com/s/files/1/0605/6086/7505/files/shipping.png?v=1702376144',
'https://cdn.shopify.com/s/files/1/0605/6086/7505/files/satisfaction.png?v=1702376143',  
'https://cdn.shopify.com/s/files/1/0605/6086/7505/files/secure_1.png?v=1702376144'
];
var badgeTexts = ["Free Shipping for Orders Over $125",
                  "Satisfaction Guarantee",
                  "Safe and Secure Checkout"];
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.product-form__buttons')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="' + imgSrcs[i] +  '"><span class="badge'+i+'">'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
} 


    

    
  }); 
}
